import { IFormValidation } from '@aston/foundation';

export class INewSubsidiaryUserValidator implements IFormValidation {
	ruleset = 'createSubsidiaryUserCommandValidator';
	fields = {
		Mail: 'Mail',
		Role: 'Role'
	};
}

export const NewSubsidiaryUserValidator = new INewSubsidiaryUserValidator();
